module.exports = __webpack_public_path__ + "img/radio-check.4786f351.svg";